import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../../base/store/actions';
import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { InfoTrackingContext } from '../models';

export default class LinearBetslipTrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/linear-tracking`;

    private static readonly LOAD_BETSLIP = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/LOAD_BETSLIP`;
    private static readonly CLICK_INFO_ICON = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/CLICK_INFO_ICON`;
    private static readonly TOGGLE_MODULE_EXPANSION = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/TOGGLE_MODULE_EXPANSION`;
    private static readonly CLICK_SYSTEM_BET_BANKER = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/CLICK_SYSTEM_BET_BANKER`;
    private static readonly LOAD_PROMOTIONS_POPUP = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/LOAD_PROMOTIONS_POPUP`;
    private static readonly LOAD_SETTINGS = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/LOAD_SETTINGS`;
    private static readonly CLICK_BETSLIP_CLOSE_CTA = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/CLICK_BETSLIP_CLOSE_CTA`;
    private static readonly CLICK_BETSLIP_DEPOSIT_CTA = `${LinearBetslipTrackingActions.ACTION_SCHEMA}/CLICK_BETSLIP_DEPOSIT_CTA`;

    static loadBetslip = createAction(LinearBetslipTrackingActions.LOAD_BETSLIP);

    static clickInfoIcon = createAction(
        LinearBetslipTrackingActions.CLICK_INFO_ICON,
        props<{ messageId: string; infoContext: InfoTrackingContext; additionalTypeContext?: string }>(),
    );

    static toggleModuleExpansion = createAction(
        LinearBetslipTrackingActions.TOGGLE_MODULE_EXPANSION,
        props<{ isExpanded: boolean; betslipType: BetslipType }>(),
    );

    static clickSystemBetBanker = createAction(LinearBetslipTrackingActions.CLICK_SYSTEM_BET_BANKER, props<{ pick: BetslipPick }>());
    static loadPromotionsPopup = createAction(LinearBetslipTrackingActions.LOAD_PROMOTIONS_POPUP, props<{ betslipType: BetslipType | undefined }>());
    static loadSettings = createAction(LinearBetslipTrackingActions.LOAD_SETTINGS);
    static clickBetslipCloseCta = createAction(LinearBetslipTrackingActions.CLICK_BETSLIP_CLOSE_CTA);
    static clickBetslipDepositCta = createAction(LinearBetslipTrackingActions.CLICK_BETSLIP_DEPOSIT_CTA);
}
